import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbcisTableComponent, ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';
import { StoreSupplierSelectorComponent } from '../store-supplier-selector/store-supplier-selector.component';

@Component({
  selector: 'app-global-supplier-store-type-config',
  standalone: false,
  templateUrl: './global-supplier-store-type-config.component.html',
  styleUrls: ['./global-supplier-store-type-config.component.scss']
})
export class GlobalSupplierStoreTypeConfigComponent implements OnInit, AfterViewInit {
  tableConfig: ABCisTableModel;

  @ViewChild(AbcisTableComponent) abcisTableComponent: AbcisTableComponent;
  @ViewChild(StoreSupplierSelectorComponent) storeSupplierSelector: StoreSupplierSelectorComponent;

  constructor(private renderer: Renderer2,
    private el: ElementRef) { }

  ngOnInit() {
    this.SetTableConfig([], []);
  }

  SetTableConfig(storeId, supplierId) {
    const urlParams = [];
    if (storeId.length > 0) {
      urlParams.push({ name: 'storeId', value: storeId.join(',') });
    }
    if (supplierId.length > 0) {
      urlParams.push({ name: 'supplierId', value: supplierId.join(',') });
    }

    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-supplier-store-type-configuration',
        urlParams: urlParams,
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'globalSupplierStoreMapId', header: 'Global Supplier Store Map', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier-store-map/lookup', isReadonly: true, isPrimary: true },
        { field: 'documentTypeCode', header: 'Document Type Code', type: ColumnType.DropDown, setUrl: 'document-type/lookup', isPrimary: true },
        { field: 'defaultPriority', header: 'Default Priority', type: ColumnType.String },
        { field: 'defaultOrderFlag', header: 'Default Order Flag', type: ColumnType.DropDown, setUrl: 'order-flag/lookup' },
        { field: 'isDocumentDiscarded', header: 'is Document Discarded', type: ColumnType.Boolean },
        { field: 'isEdiConfigured', header: 'is EDI Configured', type: ColumnType.Boolean },
        { field: 'isPurchaseOrderNumberRequired', header: 'is Purchase Order Number Required', type: ColumnType.Boolean },
        { field: 'isAutocompleteAllowed', header: 'is AutoComplete Allowed', type: ColumnType.Boolean },
        { field: 'poolId', header: 'Pool Name', type: ColumnType.MultiSelectComplex, setUrl: 'pool-group/lookup/1' }
      ],
      addFormConfig: {
        header: 'Add Global Supplier Store Type'
      },
      isConfigurable: true,
    };
  }

  ngAfterViewInit() {
    // default - disabled 'Add' button
    const addButton = this.el.nativeElement.querySelector('button[label="Add"]');
    this.renderer.setAttribute(addButton, 'disabled', 'true');
    // add form

    const mainAddForm = this.abcisTableComponent.showAddRowDialog;
    this.abcisTableComponent.showAddRowDialog = () => {
      mainAddForm.call(this.abcisTableComponent);

      setTimeout(() => {
        // Find the column and set its dataset
        const globalSupplierStoreMapColumn = this.abcisTableComponent.cols.find(col => col.field === 'globalSupplierStoreMapId');
        if (globalSupplierStoreMapColumn && globalSupplierStoreMapColumn.columnset) {
          const existingData = globalSupplierStoreMapColumn.columnset.find(item => item.value == this.storeSupplierSelector.globalSupplierStoreMapId);
          if (existingData) {
            globalSupplierStoreMapColumn.dataset = [existingData];
            globalSupplierStoreMapColumn.allowedInsertDataset = [existingData];
          }
        }
        this.abcisTableComponent.addingForm.get('globalSupplierStoreMapId').setValue(this.storeSupplierSelector.globalSupplierStoreMapId);
      }, 50);
    };

    // search
    const mainSearchSelector = this.storeSupplierSelector.onSearchClick;
    this.storeSupplierSelector.onSearchClick = () => {
      mainSearchSelector.call(this.storeSupplierSelector);
      this.SetTableConfig(this.storeSupplierSelector.selectedStoreId, this.storeSupplierSelector.selectedSupplierId);
    };
  }
}
